import { useMemo, useState } from "react";
import AnnouncementPost from "./AnnouncementPost";
import Search from "../../../CommonComponents/Search";
import { useEffect } from "react";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import { useParams } from "react-router-dom";
import constants from "../../../../constants";
import RichTextEditor from "../../../CommonComponents/RichTextEditor";
import { useContext } from "react";
import AlertContext from "../../../../context/AlertContext";
import useS3FileManagement from "../../../../Hooks/useS3FileManagement";
import Checkbox from "../../../CommonComponents/Checkbox";
import InputField from "../../../CommonComponents/InputField";
import Button from "../../../Button";
import DragAndDropUpload from "../../../CommonComponents/DragAndDropUpload";
import { nanoid } from "nanoid";
import Loading from "../../../Notification-Loading/Loading/Loading";
import Tooltip from "../../../CommonComponents/Tooltip";
import { useDebouncedValue } from "../../../../Hooks/useDebounceValue";
import { getDataFromStorage } from "../../../../util";

const ChevronLeft = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#344054"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

// ─── Upload File Component ───
const UploadFile = ({
  attachments,
  handleDeleteAttachments,
  onUpload,
  supportFormat,
}) => {
  return (
    <div className="assignment-attachment-container">
      <div className="dragAndDropUploadTopSec">
        <div className="dragAndDropUploadText">Drag & Drop your image</div>
        <div className="dragAndDropUploadSupFormat">
          Supported formats ({supportFormat})
        </div>
      </div>
      <div className="dragAndDropUploadOrText">or</div>
      <input
        type="file"
        multiple
        id="fileInput"
        onChange={onUpload}
        accept={supportFormat}
        className="dragAndDropUploadInput"
      />
      <div className="dragAndDropUploadBtn">
        <Button
          size="sm"
          hierarchy={{ type: "secondaryGrey", buttonText: "Upload file" }}
          icon={{
            icon: (
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 12.5V15.8333C18 16.2754 17.8244 16.6993 17.5118 17.0118C17.1993 17.3244 16.7754 17.5 16.3333 
                  17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V12.5M14.6667 
                  6.66667L10.5 2.5M10.5 2.5L6.33333 6.66667M10.5 2.5V12.5"
                  stroke="#344054"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ),
            type: "leading",
          }}
        />
      </div>
    </div>
  );
};

const validator = {
  title: (value) =>
    !value || value.trim() === "" ? "Title is required" : null,
  description: (value) =>
    !value || value.trim() === "" ? "Description is required" : null,
};

const CreateNoticeForm = ({
  onBack,
  onPublish,
  editingPost = [],
  postLoading,
  setPostLoading,
}) => {
  const axios = useAxiosPrivate();
  const { getCatchBlockDetails } = useCommonFunctionHooks();
  const { onUploadS3Object, getPreSignedUrl } = useS3FileManagement();
  const { id } = useParams();
  const { setShowNotify } = useContext(AlertContext);
  const [attachedFiles, setAttachedFiles] = useState(
    editingPost
      ? [
          ...(editingPost.attachments || []).map((n) => ({
            url: n.url,
            isdownloadable: n.isdownloadable,
            id: n.id,
          })),
          ...(editingPost.images || []).map((n) => ({
            url: n.url,
            isdownloadable: n.isdownloadable,
            id: n.id,
          })),
        ]
      : [],
  );
  const [filesFromLib, setFilesFromLib] = useState(
    editingPost
      ? [
          ...(editingPost.attachments || []).map((n) => ({
            url: n.url,
            isdownloadable: n.isdownloadable,
            id: n.id,
          })),
          ...(editingPost.images || []).map((n) => ({
            url: n.url,
            isdownloadable: n.isdownloadable,
            id: n.id,
          })),
        ]
      : [],
  );

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    attachments: [],
    allowComments: true,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    // console.log("\n\n\n\nUseEffect");

    if (editingPost) {
      setFormData({
        title: editingPost.title || "",
        description: editingPost.description || "",
        attachments: [
          ...(editingPost.attachments || []).map((n) => ({
            url: n.url,
            isdownloadable: n.isdownloadable,
            id: n.id,
          })),

          ...(editingPost.images || []).map((n) => ({
            url: n.url,
            isdownloadable: n.isdownloadable,
            id: n.id,
          })),
        ],
        allowComments: editingPost.allowComments ?? true,
      });
    }
  }, [editingPost]);

  // const removeFile = (i) => setAttachedFiles(prev => prev.filter((_, idx) => idx !== i));
  const handlePublish = async () => {
    try {
      const titleError = validator.title(formData.title);
      const descriptionError = validator.description(formData.description);

      const allErrors = {
        title: titleError,
        description: descriptionError,
      };
      setErrors(allErrors);
      const hasErrors = Object.values(allErrors).some(
        (error) => error !== null,
      );
      if (hasErrors) {
        return;
      }
      let keyArr = [];
      let isdownArr = [];
      // console.log("attachedfILES:", attachedFiles);
      setPostLoading(true);
      try {
        for (let i = 0; i < attachedFiles.length; i++) {
          const attachment = attachedFiles[i];
          console.log("attaaaaaaaaa:", attachment);

          const actualFile = attachment.file;
          // already uploaded file
          if (!(attachment.file instanceof File)) {
            keyArr.push(attachment.key || attachment.name || attachment.url);
            isdownArr.push(attachment.isdownloadable);
            continue;
          }

          let date = new Date();
          const key = `announcement/${id}/${date.getTime()}${actualFile.name}`;
          await onUploadS3Object(
            key,
            actualFile,
            actualFile.type.split("/")[1],
            undefined,
            "PUT",
          );
          keyArr.push(key);
          isdownArr.push(attachment.isdownloadable);
        }
      } catch (error) {
        console.log("error in uploading and generating key:", error);
        getCatchBlockDetails(error);
        return;
      }
      console.log("keyArr:", keyArr);
      console.log("isDonw:", isdownArr);
      const method = editingPost?.id ? "put" : "post";
      const url = editingPost?.id
        ? `node/announcement/${editingPost.id}`
        : "node/announcement";
      const response = await axios[method](`${url}?batchid=${id}`, {
        description: formData.description,
        allow_comments: formData.allowComments,
        title: formData.title,
        key: keyArr,
        isdownloadable: isdownArr,
      });
      if (response.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        throw new Error("Something Went Wrong");
      }
      // setPosts(response.data.data);
      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        onBack();
        setShowNotify({
          show: true,
          title: "Info",
          msg: response.data.msg,
        });
      }
      console.log("response:", response);
    } catch (error) {
      getCatchBlockDetails(error);
    } finally {
      setPostLoading(false);
    }
  };

  // console.log("editPOstin:", editingPost);
  // console.log("formData:", formData);
  // console.log("attachedFiles:", attachedFiles);
  // console.log("filesFromLib:", filesFromLib);

  const supportedFormat = ["jpg", "jpeg", "png"];

  const uploadFiles = (files = [], event) => {
    const isUploadableFormat = files.every((file) =>
      supportedFormat.includes(file.type.split("/")[1]),
    );
    if (!isUploadableFormat) {
      setShowNotify({
        show: true,
        title: "Warning",
        msg: "Please upload the supported file",
      });
      return;
    }
    let commentedDate = String(new Date());
    let newAttachment = [...attachedFiles];
    let files1 = Array.from(event.target.files);

    console.log("files1:", files1);

    for (let i = 0; i < files1.length; i++) {
      let attachment = {
        id: nanoid(),
        file: files1[i],
        date: commentedDate,
        isdownloadable: false,
      };
      newAttachment.push(attachment);
    }
    console.log("newAttachment:", newAttachment);
    setAttachedFiles(newAttachment);
    setFormData((prev) => ({
      ...prev,
      attachments: [...newAttachment],
    }));
  };
  const onUpload = (event) => {
    const files = Array.from(event.target.files);
    console.log("files:", files);

    uploadFiles(files, event);
    event.target.value = "";
  };

  const handleDeleteAttachments = (attachmentId) => {
    console.log("delete clicked:", attachmentId);

    setFormData((prev) => ({
      ...prev,
      attachments: prev.attachments.filter(
        (attachment) => attachment.id !== attachmentId,
      ),
    }));
    setFilesFromLib((prev) =>
      prev.filter((attachment) => attachment.id !== attachmentId),
    );
    setAttachedFiles((prevAttachment) =>
      prevAttachment.filter((attachment) => attachment.id !== attachmentId),
    );
  };

  const openFile = async (file) => {
    console.log("file:", file);
    if (file.hasOwnProperty("url")) {
      const preSignedData = await getPreSignedUrl(
        file.url,
        undefined,
        file.url.split(".").pop(),
        "GET",
      );
      console.log("presignedData:", preSignedData);
      window.open(preSignedData.url, "_blank");
    } else {
      const fileURL = URL.createObjectURL(file.file);
      window.open(fileURL, "_blank");
    }
  };

  return (
    <div className="create-notice-container">
      {/* ── Header ── */}
      <div className="create-notice-header">
        <button className="create-notice-back-button" onClick={onBack}>
          <ChevronLeft />
        </button>
        <div className="create-notice-header-text">
          <div className="create-notice-title">
            {editingPost ? "Edit notice" : "Create notice"}
          </div>
          <div className="create-notice-subtitle">
            Stay updated with the new announcements
          </div>
        </div>
      </div>

      {postLoading && <Loading overlay/>}

      <div className="create-notice-form-card">
        {/* Subject Field */}
        <div className="create-notice-field">
          <InputField
            label="Subject"
            name="name"
            placeholder="Title of the notice"
            value={formData.title}
            onChange={(e) => {
              const error = validator["title"]
                ? validator["title"](e.target.value)
                : null;
              setFormData((p) => ({ ...p, title: e.target.value }));
              setErrors((prev) => ({
                ...prev,
                ["title"]: error,
              }));
            }}
            hintText={errors.title}
            destructive={!!errors.title}
          />
        </div>

        {/* Description Field */}
        <div className="create-notice-field">
          <RichTextEditor
            title="Description"
            name="description"
            value={formData.description}
            onChange={(event) => {
              const error = validator["description"]
                ? validator["description"](event)
                : null;
              setFormData((p) => ({ ...p, description: event }));
              setErrors((prev) => ({
                ...prev,
                description: error,
              }));
            }}
            hintText={errors.description}
            destructive={!!errors.description}
          />
        </div>

        <div className="admin-notice-attachments">
          <DragAndDropUpload
            onUpload={onUpload}
            file={formData.attachments}
            isMultiUpload={false}
            text="Drop your attachment"
            uploadedFile={
              <UploadFile
                attachments={formData.attachments}
                handleDeleteAttachments={handleDeleteAttachments}
                onUpload={onUpload}
                supportFormat={".jpg,.png,.jpeg"}
              />
            }
          />
          <div className="admin-notice-attachments-upload-files-container">
            {formData.attachments.length >= 1 &&
              formData.attachments.map((file) => (
                <div className="admin-notice-attachments-upload-files-content-container">
                  <div className="admin-notice-attachments-upload-file-detail">
                    <div
                      className="admin-notice-attachments-upload-file-detail-name"
                      onClick={() => openFile(file)}
                    >
                      <svg
                        width="18"
                        height="22"
                        viewBox="0 0 18 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 
                          1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 
                          20.4142C16.7893 20.0391 17 19.5304 17 19V8M10 1L17 8M10 1V8H17"
                          stroke="#344054"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <Tooltip
                        title={file?.file?.name ?? file?.url?.split("/").pop()}
                        placement="bottom"
                        className="notice-file-attachment-name"
                      >
                        <p
                          style={{
                            width: "98%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {file?.file?.name ?? file?.url?.split("/").pop()}
                        </p>
                      </Tooltip>
                    </div>
                    <svg
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => handleDeleteAttachments(file.id)}
                    >
                      <path
                        d="M0.5 3.16667H1.83333M1.83333 3.16667H12.5M1.83333 3.16667V12.5C1.83333 12.8536 1.97381 13.1928 
                        2.22386 13.4428C2.47391 13.6929 2.81304 13.8333 3.16667 13.8333H9.83333C10.187 13.8333 10.5261 13.6929 
                        10.7761 13.4428C11.0262 13.1928 11.1667 12.8536 11.1667 12.5V3.16667H1.83333ZM3.83333 
                        3.16667V1.83333C3.83333 1.47971 3.97381 1.14057 4.22386 0.890524C4.47391 0.640476 4.81304 0.5 
                        5.16667 0.5H7.83333C8.18696 0.5 8.52609 0.640476 8.77614 0.890524C9.02619 1.14057 9.16667 1.47971 
                        9.16667 1.83333V3.16667M5.16667 6.5V10.5M7.83333 6.5V10.5"
                        stroke="#F04438"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <Checkbox
                    supportingText="Attachment Downloadable"
                    checked={file.isdownloadable}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        attachments: prev.attachments.map((t) =>
                          t.id === file.id
                            ? { ...t, isdownloadable: value }
                            : t,
                        ),
                      }));
                      setFilesFromLib((prev) =>
                        prev.map((tc) =>
                          tc.id === file.id
                            ? { ...tc, isdownloadable: value }
                            : tc,
                        ),
                      );
                      setAttachedFiles((prev) =>
                        prev.map((tc) =>
                          tc.id === file.id
                            ? { ...tc, isdownloadable: value }
                            : tc,
                        ),
                      );
                    }}
                  />
                </div>
              ))}
          </div>
        </div>

        <Checkbox
          text="Allow Comment section to this post."
          checked={formData.allowComments}
          onChange={(checked) =>
            setFormData((prev) => ({
              ...prev,
              allowComments: checked,
            }))
          }
        />

        {/* Action Buttons */}
        <div className="create-notice-actions">
          <Button
            size="sm"
            onClick={onBack}
            hierarchy={{
              type: "secondaryGrey",
              buttonText: "Cancel",
            }}
            disable={postLoading}
          />
          <Button
            size="sm"
            onClick={handlePublish}
            hierarchy={{
              type: "primary",
              buttonText: "Publish notice",
            }}
            disable={postLoading}
          />
        </div>
      </div>
    </div>
  );
};

// ─── Main Admin Notices Page ──────────────────────────────────────────────────

export default function AdminNotices() {
  const axios = useAxiosPrivate();
  const { getCatchBlockDetails } = useCommonFunctionHooks();
  const { getPreSignedUrl } = useS3FileManagement();
  const [view, setView] = useState("list");
  const [searchQuery, setSearchQuery] = useState("");
  const [posts, setPosts] = useState([]);
  const [editingPost, setEditingPost] = useState(null);
  const { id } = useParams();
  const [postLoading, setPostLoading] = useState(false);

  const debounceSearchQuery = useDebouncedValue(searchQuery, 500);

  const filteredPosts = useMemo(() => {
    return posts.filter(
      (p) =>
        (p.title &&
          p?.title
            ?.toLowerCase()
            .includes(debounceSearchQuery.toLowerCase())) ||
        (p.description &&
          p?.description
            ?.toLowerCase()
            .includes(debounceSearchQuery.toLowerCase())),
    );
  }, [debounceSearchQuery, posts]);


  useEffect(() => {
    if (view === "list") {
      fetchAnnouncementDetails();
    }
  }, [view]);

  const fetchAnnouncementDetails = async () => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
    try {
      setPostLoading(true);
      const response = await axios.get(`/node/announcement?batchid=${id}&companyId=${getDataFromStorage("companyId")}`);
      if (response.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        throw new Error("Something Went Wrong");
      }
      let allPost = JSON.parse(JSON.stringify(response.data.data));
      for (let post of allPost) {
        let preSignedUrl = [];
        let attachment =
          typeof post.attachments === "object"
            ? post.attachments
            : JSON.parse(post.attachments);
        const images = attachment.filter((file) =>
          imageExtensions.includes(file.url.split(".").pop()?.toLowerCase()),
        );

        const files = attachment.filter(
          (file) =>
            !imageExtensions.includes(file.url.split(".").pop()?.toLowerCase()),
        );

        for (let image of images) {
          let fileTypeArr = [];
          let fileNameArr = [];
          let key = image.url;
          fileTypeArr.push(image.url.split(".").pop());
          fileNameArr.push(image.url.split(".")[0].split("/").pop());
          let pre = await getPreSignedUrl(key, undefined, fileTypeArr, "GET");
          preSignedUrl.push({
            url: pre.url,
            isdownloadable: image.isdownloadable,
            id: nanoid(),
          });
        }

        for (let a of attachment) {
          a.id = nanoid();
        }
        post.attachments = files;
        post.images = images;
        post.preSignedUrl = preSignedUrl;
      }
      setPosts(allPost);
    } catch (error) {
      getCatchBlockDetails(error);
    } finally {
      setPostLoading(false);
    }
  };

  const handleEdit = (post) => {
    console.log("editing");
    setEditingPost(post);
    setView("edit");
    setPosts([])
  };

  const handlePublish = (data) => {
    if (editingPost) {
      setPosts((prev) =>
        prev.map((p) =>
          p.id === editingPost.id
            ? {
                ...p,
                title: data.subject || p.title,
                description: data.description || p.description,
                attachments: data.attachedFiles.map((f) => f.name || f),
              }
            : p,
        ),
      );
    } else {
      const newPost = {
        id: Date.now(),
        author: "Gradious Admin",
        batch: "FSD Batch 1",
        time: new Date().toLocaleString(),
        badge: "Exam",
        title: data.subject || "New Notice",
        description: "",
        attachments: data.attachedFiles.map((f) => f.name || f),
        likes: 0,
        saves: 0,
      };
      setPosts((prev) => [newPost, ...prev]);
    }
    setEditingPost(null);
    setView("list");
  };

  return (
    <div className="admin-notices-page-container">
      {/* {postLoading && <Loading overlay/>} */}
      <main className="admin-notices-main-content">
        {/* ── List View ── */}
        {view === "list" && (
          <div className="admin-notices-list-view">
            <div className="admin-notices-list-header">
              <div className="admin-notices-list-title-section">
                <div className="admin-notices-list-title">
                  Published notices
                </div>
                <div className="admin-notices-list-subtitle">
                  View the published notices.
                </div>
              </div>
              <div className="admin-notices-list-actions">
                <Search
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  height="40px"
                />
                <Button
                  size="md"
                  hierarchy={{ type: "primary", buttonText: "Add new notices" }}
                  icon={{
                    type: "leading",
                    icon: <div className="admin-notices-add-button-dot" />,
                  }}
                  onClick={() => {
                    setEditingPost(null);
                    setView("create");
                    setPosts([])
                  }}
                />
              </div>
            </div>

            <div className="admin-notices-posts-container">
              {filteredPosts.map((post) => (
                <div key={post.id} className="admin-notices-post-wrapper">
                  <AnnouncementPost
                    isAdmin={true}
                    onEdit={() => handleEdit(post)}
                    authorName={post.author}
                    postedTo={post.batch}
                    timestamp={post.time}
                    badgeLabel={post.badge}
                    title={post.title}
                    description={post.description}
                    attachments={
                      typeof post.attachments === "object"
                        ? post.attachments
                        : JSON.parse(post.attachments) ?? []
                    }
                    images={
                      typeof post.preSignedUrl === "object"
                        ? post.preSignedUrl
                        : JSON.parse(post.preSignedUrl) ?? []
                    }
                    initialLikes={post.likes}
                    post={post}
                    initialComments={
                      typeof post.comments === "object"
                        ? post.comments
                        : JSON.parse(post.comments) ?? []
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── Create / Edit View ── */}
        {(view === "create" || view === "edit") && (
          <div className="admin-notices-form-view">
            <CreateNoticeForm
              onBack={() => {
                setEditingPost(null);
                setView("list");
              }}
              onPublish={handlePublish}
              editingPost={editingPost}
              setEditingPost={setEditingPost}
              postLoading={postLoading}
              setPostLoading={setPostLoading}
            />
          </div>
        )}
      </main>
    </div>
  );
}
